var _mask, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmptySocialNetworks = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 153,
  height: 153,
  viewBox: "0 0 153 153",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 153,
  height: 153
}, /*#__PURE__*/React.createElement("circle", {
  cx: 76.5,
  cy: 76.5,
  r: 76.5,
  fill: "#F3F6F9"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 76.5,
  cy: 76.5,
  r: 76.5,
  fill: "#E9ECEF"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 43,
  y: 29,
  width: 165,
  height: 129,
  fill: "#F8F8FD"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 43,
  y: 29,
  width: 165,
  height: 41,
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_d)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 56,
  y: 81,
  width: 149,
  height: 48,
  rx: 2,
  fill: "white"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 67,
  cy: 93,
  r: 5,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 93,
  r: 5,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 67,
  cy: 117,
  r: 5,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 117,
  r: 5,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("rect", {
  x: 55,
  y: 40,
  width: 45,
  height: 6,
  rx: 3,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("rect", {
  x: 90,
  y: 89,
  width: 18,
  height: 2,
  rx: 1,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("rect", {
  x: 90,
  y: 94,
  width: 45,
  height: 2,
  rx: 1,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("rect", {
  x: 90,
  y: 113,
  width: 18,
  height: 2,
  rx: 1,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("rect", {
  x: 90,
  y: 118,
  width: 45,
  height: 2,
  rx: 1,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("rect", {
  x: 55,
  y: 53,
  width: 136,
  height: 6,
  rx: 3,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("rect", {
  x: 104,
  y: 40,
  width: 72,
  height: 6,
  rx: 3,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("line", {
  opacity: 0.5,
  x1: 56,
  y1: 104.5,
  x2: 205,
  y2: 104.5,
  stroke: "#E4E8F1"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 39,
  y: 29,
  width: 173,
  height: 137,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.130469 0 0 0 0 0.254849 0 0 0 0 0.695833 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d",
  x: 41,
  y: 28,
  width: 169,
  height: 45,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_d",
  x: 54,
  y: 80,
  width: 153,
  height: 52,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})))));
export { SvgEmptySocialNetworks as ReactComponent };
export default __webpack_public_path__ + "static/media/emptySocialNetworks.32c2db3d.svg";